import React from 'react';

import getResponsiveImage from 'app/utils/getResponsiveImage';

import Button from 'app/components/Button';

import styles from './styles.css';

const Quote = ({ attribute, image, onCtaClick, quote, viewport }) => {
  const imageSrc = getResponsiveImage(image, viewport);

  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        <h3 className={styles.quote}>
          &ldquo;
          {quote}
          &rdquo;
        </h3>
        <p className={styles.attribute}>~{attribute}</p>
        {onCtaClick && (
          <Button
            onClick={onCtaClick}
            label={'Take the survey'}
            passedStyles={styles.button}
          />
        )}
      </div>

      <img src={imageSrc} alt={quote} className={styles.image} />
    </div>
  );
};

export default Quote;



// WEBPACK FOOTER //
// ./src/components/Quote/index.js